import sleevePrintDown from '~/assets/images/additionalprintareas/sleeve_print_sentenced_down.png';
import sleevePrintUp from '~/assets/images/additionalprintareas/sleeve_print_sentenced_up.png';
import sleevePrintStacked from '~/assets/images/additionalprintareas/sleeve_print_stacked.png';
import sleevePrintStandard from '~/assets/images/additionalprintareas/sleeve_print_standard.png';

import embroideredSleeveMacro from '~/assets/images/additionalprintareas/embroidery_macro_sleeve.jpg';
import embroideredSleevePolo from '~/assets/images/additionalprintareas/embroidery_polo_leftsleeve.jpg';
import embroideredSleeveJacketMale from '~/assets/images/additionalprintareas/embroidery_jacket_leftsleeve_male.jpg';
import embroideredSleeveJacketFemale from '~/assets/images/additionalprintareas/embroidery_jacket_leftsleeve_female.jpg';

import hoodPrintReadable from '~/assets/images/additionalprintareas/hood_print_readable_hood_up.png';
import hoodPrintSide from '~/assets/images/additionalprintareas/hood_print_side_hood_up.png';
import hoodPrintStandard from '~/assets/images/additionalprintareas/hood_print_standard.png';

import legPrintDown from '~/assets/images/additionalprintareas/leg_print_sentenced_down.png';
import legPrintUp from '~/assets/images/additionalprintareas/leg_print_sentenced_up.png';
import legPrintStacked from '~/assets/images/additionalprintareas/leg_print_stacked.png';

export const SLEEVE_PRINT = {
  down: sleevePrintDown,
  up: sleevePrintUp,
  stacked: sleevePrintStacked,
  standard: sleevePrintStandard
};

export const EMBROIDERED_SLEEVE_PRINT = {
  macro: embroideredSleeveMacro,
  polo: embroideredSleevePolo,
  jacket_male: embroideredSleeveJacketMale,
  jacket_female: embroideredSleeveJacketFemale
};

export const HOOD_PRINT = {
  readable: hoodPrintReadable,
  side: hoodPrintSide,
  standard: hoodPrintStandard
};

export const LEG_PRINT = {
  down: legPrintDown,
  up: legPrintUp,
  stacked: legPrintStacked
};
